import React from "react";
import { withTenantContext } from "../../api";
import type { DraftView } from "../../api/types";
import { useT } from "../../i18n";
import { signatureEditorFragment } from "../signature-editor-policy";
import styles from "../signature-editor.module.css";

/** Shows the exact frozen signature. Its CID is resolved only for this authenticated preview. */
export function SignaturePreview({ signature }: { signature: DraftView["signature"] }) {
  const t = useT();
  const [failedImage, setFailedImage] = React.useState(false);
  React.useEffect(() => setFailedImage(false), [signature?.logo?.id]);
  const html = React.useMemo(() => {
    if (!signature?.html) return "";
    const template = document.createElement("template");
    template.content.append(signatureEditorFragment(signature.html, signature.logo?.content_id ?? null));
    for (const image of Array.from(template.content.querySelectorAll("img"))) {
      const url = signature.logo?.preview_url;
      if (url?.startsWith("/api/")) image.setAttribute("src", withTenantContext(url));
      else image.remove();
    }
    return template.innerHTML;
  }, [signature]);
  if (!html) return null;
  return (
    <div className={styles.preview} data-testid="draft-signature-preview">
      <div data-ribbon-theme="light" className={styles.previewPaper} dangerouslySetInnerHTML={{ __html: html }}
        onErrorCapture={(event) => { if ((event.target as HTMLElement).tagName === "IMG") setFailedImage(true); }} />
      {failedImage && <p className={styles.error} role="alert">{t("settings.signatureLogoUnavailable")}</p>}
    </div>
  );
}
